import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "logout-prompt"
  }, [_c('div', {
    staticClass: "logout-prompt-content"
  }, [_c('a-result', {
    attrs: {
      "status": "success",
      "title": _vm.t('注销成功'),
      "sub-title": _vm.t('预计{0}秒后会自动退出', [_vm.countdown])
    }
  })], 1), _c('div', {
    staticClass: "logout-prompt-btn",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "customer_logout_account_completed_exit",
      "id": "customer_logout_account_completed_exit",
      "fbu-analyse-name": $t("\u9000\u51FA")
    },
    on: {
      "click": _vm.handleExit
    }
  }, [_vm._v(_vm._s(_vm.t('退出')))])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };